import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

export default function TextField({
    name, label, value, inputChangeCallback,
    inputBlurCallback, inputType, inputPattern, errorMessage,
}) {
    return <div className="input-holder">
        <label htmlFor={name}>{label}</label>
        <input type={inputType} name={name} id={name}
            className={errorMessage ? 'hasError' : ''}
            value={value}
            onChange={inputChangeCallback}
            pattern={inputPattern}
            onBlur={inputBlurCallback} />
        {errorMessage ? (
            <div className="error-text">{errorMessage}</div>) : null}
    </div>;
}
TextField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    inputChangeCallback: PropTypes.func.isRequired,
    inputBlurCallback: PropTypes.func,
    inputType: PropTypes.string,
    inputPattern: PropTypes.string,
    errorMessage: PropTypes.string,
};
TextField.defaultProps = {
    inputType: 'text',
};
